interface SpinnerProps {
  size?: number;
  label?: string;
}

export function Spinner({ size = 20, label }: SpinnerProps) {
  return (
    <div style={styles.wrap}>
      <div
        style={{
          ...styles.spinner,
          width: size,
          height: size,
        }}
      />
      {label && <span style={styles.label}>{label}</span>}
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  wrap: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: 12,
  },
  spinner: {
    border: "2px solid var(--comp-rule)",
    borderTopColor: "var(--fg-3)",
    borderRadius: "50%",
    animation: "spin 0.8s linear infinite",
  },
  label: {
    fontFamily: "var(--font-mono)",
    fontSize: 12,
    color: "var(--fg-3)",
  },
};
